export default __webpack_public_path__ + "static/media/e-logo.6fce621b.png";